/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import student from "../../http/requests/students/student/index.js"

export default {


    loadGeneral({ commit }, payload) {
      return new Promise((resolve,reject) => {
        student.loadGeneral(payload.id_usuario, payload.cod_persona, payload.estado)
          .then(response => {
            // If there's user data in response

            if(!response.data.existeError) {
              // Navigate User to homepage
              if(_.size(response.data.data) > 0){
                
                // router.push(router.currentRoute.query.to || '/')
  
                // // Set accessToken

                // localStorage.setItem("accessToken", response.data.accessToken)
  
                // // Update user details
                // commit('UPDATE_USER_INFO', response.data.data, {root: true})
  
                commit("SET_STUDENT", response.data.data);
  
                resolve(response)
              }
              else{
                reject({message: "No existe alumnos registrados."})
              }
            }else {
              reject({message: response.data.mensaje})
            }
          })
          .catch(error => { reject(error) })
      })
    },
    insertUpdate({ commit }, payload) {
      return new Promise((resolve,reject) => {
        student.insertUpdate(payload)
          .then(response => {
            // If there's user data in response

            if(!response.data.existeError) {
              // Navigate User to homepage
              if(_.size(response.data.data) > 0){
                // commit("SET_STUDENT", response.data.data);
                resolve(response)
              }
              else{
                resolve(response.data.mensaje)
              }
            }else {
              reject({message: response.data.mensaje})
            }
          })
          .catch(error => { reject(error) })
      })
    },
  
    selectedStudent({ commit }, payload) {
      return new Promise((resolve,reject) => {
            // If there's user data in response
            commit("SELECT_STUDENT", payload);
      })
    },
}
